import api from "./api";
import { TreatmentHistory } from "../types";

/* CREATE TREATMENT HISTORY RECORD */
export const createTreatmentHistory = async (data: FormData): Promise<TreatmentHistory> => {
  const res = await api.post("/treatmenthistory/create", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data.data;
};

/* GET ALL TREATMENT HISTORY RECORDS BY PATIENT ID */
export const getTreatmentHistoryByPatientId = async (patientId: string): Promise<TreatmentHistory[]> => {
  const res = await api.get(`/treatmenthistory/patient/${patientId}`);
  return res.data.data;
};

/* UPDATE TREATMENT HISTORY RECORD */
export const updateTreatmentHistory = async (
  id: number,
  formData: FormData
): Promise<TreatmentHistory> => {
  const res = await api.put(`/treatmenthistory/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data.data;
};

/* DELETE TREATMENT HISTORY RECORD */
export const deleteTreatmentHistory = async (id: number): Promise<any> => {
  const res = await api.delete(`/treatmenthistory/${id}`);
  return res.data.data;
};

/* VIEW DOCUMENT */
export const viewTreatmentHistoryDocument = async (id: number): Promise<string> => {
  const res = await api.get(`/treatmenthistory/${id}/document`);
  let url = res.data?.data?.url || res.data?.url;
  if (!url) {
    throw new Error("Failed to open document");
  }
  if (url.startsWith("/")) {
    const apiBase = (api.defaults.baseURL || "http://localhost:5000/api").replace(/\/api\/?$/, "");
    url = `${apiBase}${url}`;
  }
  return url;
};
